// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__7vgBY","content":"MainLayout_content__nOiKO"};